import service from '@/services/superaccess'

const ConfigurationModule = {
  state: {
    modal: false
  },
  getters: {
    getModalConfigStatus (state) {
      return state.modal
    }
  },
  mutations: {
    setModalConfigStatus (state, status) {
      state.modal = status
    }
  },
  actions: {
    changeModalConfigStatus (context, payload) {
      context.commit('setModalConfigStatus', payload)
    },
    getTypes (context, payload) {
      return service.get('/api/types', context)
    },
    getPermissions (context, payload) {
      return service.post('/api/permission/all', context)
    },
    postRegisterConfig (context, payload) {
      payload = JSON.parse(JSON.stringify(payload))
      if (payload.option[0].key === '') {
        delete payload.option
      }
      return service.post('/api/config/create', context, payload)
    },
    changeStatusConfig (context, payload) {
      return service.patch('/api/config/change', context, payload)
    },
    getDetailConfig (context, payload) {
      return service.get(`/api/config/${payload}`, context)
    },
    editRegisterConfig (context, payload) {
      payload = JSON.parse(JSON.stringify(payload))
      if (payload.option[0].key === '') {
        delete payload.option
      }
      return service.patch('/api/config/modify', context, { payload })
    }
  }
}

export default ConfigurationModule



// WEBPACK FOOTER //
// app/javascript/src/store/configuration.js